
<ion-row class="gallery-wrapper">
  <!-- Hidden LightGallery for functionality only -->
  @defer (when isBrowser) {
    <div style="display: none;">
      <lightgallery
        [settings]="settingsGallery"
        [onInit]="onInit"
        [onBeforeSlide]="onBeforeSlide"
      >
        <a *ngFor="let album of _albums; let i = index" [href]="album.src">
          <img [src]="album.thumb" [alt]="album.caption" />
        </a>
      </lightgallery>
    </div>
  }

  @defer {
    <ion-col size="12" size-lg="6" style="position: relative;">
      <div class="labels_wrapper">
        <span class="_lbl" [class.primary]="isParent">{{isParent && subCatName?.nameEn === 'Apartments' ? 'Property' : subCatName?.nameEn}}</span>

        @if (labelText) {
          <span class="_lbl_small">{{labelText}}</span>
        }
      </div>
      <swiper-container #thumbsSwiper
                        class="thumbSwiper"
                        loop="true" space-between="10">
        @for (img of imagesList; track img; let i = $index) {
          <swiper-slide>
            <div class="image-card">
              <ion-img (click)="open(i)" [src]="img.filepath" alt="Satel Realty Riyadh"></ion-img>
            </div>
          </swiper-slide>
        }
      </swiper-container>
      <ion-button class="show-all-button ion-hide-sm-up" (click)="open(0)" size="small" aria-label="Show all photos"><ion-icon name="grid"></ion-icon> Show all photos</ion-button>
    </ion-col>
    <ion-col size="3" size-lg="6">
      <div class="image-thumb-gallery ion-hide-sm-down"
           [class.small]="size === 'small'">
        @if (videoUrl) {
          <div class="grid-item video-thumb" id="showVideo"
               [style.background-image]="isDrive ? 'url(' + imagesList[0].filepath +')'  : 'url(https://img.youtube.com/vi/' + videoId + '/0.jpg)'">
            <div class="v-overlay">
              <ion-icon name="logo-youtube"></ion-icon>
              <span>Watch Video</span>
            </div>
          </div>
          <ion-modal class="video-modal" trigger="showVideo" #showVideoModal>
            <ng-template>
              @if (isDrive) {
                <iframe [src]="driveUrl" style="aspect-ratio: 16/9" [frameBorder]="0" allow="autoplay" allowfullscreen></iframe>
              } @else {
                <youtube-player
                  #ytPlayer
                  [videoId]="videoId" placeholderImageQuality="standard"/>
              }
                <div class="ion-text-right" style="display: flex; justify-content: flex-end; padding: 4px 5px;">
                  <ion-buttons>
                    <ion-button color="dark" (click)="showVideoModal.dismiss()">
                      <ion-icon name="close"></ion-icon>
                    </ion-button>
                  </ion-buttons>
                </div>
            </ng-template>
          </ion-modal>
        }
        @for (img of propertyThumbs; track img; let i = $index; let last = $last) {
          <div class="grid-item">
            <ion-img (click)="open(i)" [src]="img.filepath" alt="Satel Realty Riyadh"></ion-img>
            @if (last) {
              <ion-button class="show-all-button ion-hide-sm-down" (click)="open(0)" size="small" aria-label="Show all photos"><ion-icon name="grid"></ion-icon> Show all photos</ion-button>
            }
          </div>
                }
      </div>
    </ion-col>
  }
</ion-row>
